// extracted by mini-css-extract-plugin
export var actions = "generator-tour-module--actions--g9Xwl";
export var backButton = "generator-tour-module--back-button---Jcj8";
export var counter = "generator-tour-module--counter--xjFli";
export var description = "generator-tour-module--description--Ck06r";
export var dismissLayer = "generator-tour-module--dismiss-layer--mat2W";
export var highlight = "generator-tour-module--highlight--sU1Gw";
export var navigation = "generator-tour-module--navigation--DQfht";
export var nextButton = "generator-tour-module--next-button--bNfc2";
export var progress = "generator-tour-module--progress--9a47s";
export var progressActive = "generator-tour-module--progress-active--1tHkH";
export var skipButton = "generator-tour-module--skip-button--aFsVu";
export var tooltip = "generator-tour-module--tooltip--X874W";
export var tooltipRight = "generator-tour-module--tooltip-right--1Wfe5";
export var tooltipTop = "generator-tour-module--tooltip-top--HVUH4";
export var tour = "generator-tour-module--tour--NAe2G";